import * as React from 'react';
import { connect } from 'react-redux';
import { Accordion, Card, Dropdown } from 'react-bootstrap';
import './PolicyDetails.css';
import { Link } from 'react-router-dom';
import { DASHBOARD, FNOL_SUBMIT_CLAIM, PERSONAL_INSURANCE } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { showComingSoon, showCallMeModal, showAddVap, showAddAccessory, showAddCarHire, showTyreAndRim, showAddCreditShortfall, showAddLittleDings, showErrorModal, showBankingDetails, showCancelPolicyEdit, showCancelVapPopup, showAddNewItem, showAddRafAssist, showUpdatePolicyModal, showRemoveCoverModal } from '../../../actions/modalActions';
import { Image } from 'react-bootstrap';
import { navigateTo } from '../../../actions/navigationActions';
import { acceptQuote, addProduct, updateExcess, toggleRaf, removeCoverFromQuote, removeAccessoryFromQuote, editPolicyRiskItems, getQuoteMobilePaymentSchedule } from '../../../actions/salesActions';
import { COMPREHENSIVE_CAR_COVER_TYPE, AGREED_VALUE_COVER_TYPE, THIRDPARTY_CAR_COVER_TYPE, THIRDPARTY_FIRETHEFT_CAR_COVER_TYPE, THEFT_WRITEOFF_CAR_COVER_TYPE, PRODUCT_COMPREHENSIVE_CAR, CHILLI_CAR_COVER_TYPE } from '../../../constants/constants';
import { VAPS_ADD_COMBINED, VAPS_ADD_TYRE_SCRATCH } from '../../../constants/copy';
import { refreshUpdatedCartItem } from '../../../actions/cartActions';
import { getSelfInspectPhotos, syncCoverWithProfile, toggleHasError, toggleSelfInspectPhotos } from '../../../actions/selfInspectActions';
import { setCoverFromPersonalInsurance, clearSelectedDamages, resetFNOL, setStep } from '../../../actions/claimSubmitActions';
import CancelCoverReasons from '../CancelCoverReasons/CancelCoverReasons';
import { AMEND_POLICY_CAR } from '../../../constants/products';
import SelfinspectDetails from '../../SelfInspection/SelfinspectDetails/SelfinspectDetails';
import OptionalExtraTile from '../OptionalExtraTile';
import AgreedValueBlock from '../../OnlineQuotation/AgreedValue/AgreedValueBlock/AgreedValueBlock';
import ReactTooltip from 'react-tooltip';
import { SA_COUNTRY_ID_NUMBER } from '../../../constants/internationalization';
import FAQItem from '../../FAQ/FAQItem';

class PolicyDetailsCar extends React.PureComponent<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            selectedExcessDropdown: false,
            showMore: false,
            reminderDismissed: false,
            updateReminderDismissed: false,
            updateEditing: false,
            accordian0Open: false,
            updateAccordian0Open: false,
            accordian1Open: false,
            updateAccordian1Open: false,
            accordian2Open: false,
            updateAccordian2Open: false,
            cancelCoverReasons: false,
            accordionFAQActiveKey: -1,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleExcessDropdownToggle = this.handleExcessDropdownToggle.bind(this);
        this.handleExcessSelection = this.handleExcessSelection.bind(this);
        this.handleShowMore = this.handleShowMore.bind(this);
        this.handleAddVap = this.handleAddVap.bind(this);
        this.handleAddAccesory = this.handleAddAccesory.bind(this);
        this.handleEditAccesory = this.handleEditAccesory.bind(this);
        this.handleAddVapCredit = this.handleAddVapCredit.bind(this);
        this.handleAddVapCarHire = this.handleAddVapCarHire.bind(this);
        this.handleAddVapTyreAndRim = this.handleAddVapTyreAndRim.bind(this);
        this.handleAddVapLittleDings = this.handleAddVapLittleDings.bind(this);
        this.handleAddVapScratchAndDent = this.handleAddVapScratchAndDent.bind(this);
        this.handleAcceptQuote = this.handleAcceptQuote.bind(this);
        this.handleAccordianArrow = this.handleAccordianArrow.bind(this);
        this.editPolicyInfo = this.editPolicyInfo.bind(this);
        this.saveEdit = this.saveEdit.bind(this);
        this.dismissInspectionReminder = this.dismissInspectionReminder.bind(this);
        this.handleSelfInspectionRequired = this.handleSelfInspectionRequired.bind(this);
        this.submitAClaim = this.submitAClaim.bind(this);
        this.handleCallMeBackModal = this.handleCallMeBackModal.bind(this);
        this.addNewProduct = this.addNewProduct.bind(this);
        this.ShowCancelEdit = this.ShowCancelEdit.bind(this);
        this.ShowCallBackVap = this.ShowCallBackVap.bind(this);
        this.handleNewItem = this.handleNewItem.bind(this);
        this.handleAddVapRafAssist = this.handleAddVapRafAssist.bind(this);
        this.toggleRaf = this.toggleRaf.bind(this);
        this.handleRemoveVap = this.handleRemoveVap.bind(this);
        this.handleRemoveAccessory = this.handleRemoveAccessory.bind(this);
        this.handleCoverRemoval = this.handleCoverRemoval.bind(this);
        this.handleShowSelfInspectPhotos = this.handleShowSelfInspectPhotos.bind(this);
        this.handleToggleReasons = this.handleToggleReasons.bind(this);
        this.handleAccordianArrow = this.handleAccordianArrow.bind(this);
        this.getDropdownItems = this.getDropdownItems.bind(this);
    }

    componentDidMount() {
        this.props.dispatchToggleHasError(false);
        this.props.dispatchToggleSelfInspectPhotos(false);
    }

    getDropdownItems(items:any){
        let faqSet = [{
            header: "Regular driver",
            body: '<div class="form-group"><div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Name</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.firstName + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Surname</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.surname + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">ID no.</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.idNumber + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Date of birth</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.dateOfBirth + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Licence type</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.licenseCode + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Licence year</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].regularDriver.licenseIssueDate + '</p>' +
                '</div>',
            id: 1
        },
        {
            header: "Car Details",
            body: '<div class="form-group"><div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Year</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.year + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Colour</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.colour + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Reg no.</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.registrationNumber + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Vin no.</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.vinNumber + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Engine no.</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.engineNumber + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Use</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.vehicleUse + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Imported</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].vehicleDetails.vehicleImported + '</p>' +
                '</div>',
            id: 2
        },
        {
            header: "Insurance history",
            body: '<div class="form-group"><div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Comprehensive cover</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].insuranceDuration + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Last theft claim</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].lastStolenClaim + '</p>' +
                '</div>' +

                '<div class="form-group row noma">' +
                '<p class="col-7 col-form-label">Last accident claim</p>' +
                '<p class="additional-cover-sub-header col-5 col-form-label text-right">' + items.riskItems[0].lastAccidentClaim + '</p>' +
                '</div>',
            id: 3
        },
        ];

        let faq;
        if (faqSet) {
            faq = faqSet.map((item) => {
                if (item.header !== "") {
                    return <FAQItem className="mb-12px" header={item.header} body={item.body} keyId={item.id} activeKey={this.state.accordionFAQActiveKey} />
                }
            });
        }

        return faq;
    }

    async handleExcessSelection(e: any) {
        /* eslint eqeqeq: "off" */
        let excessItem = this.props.sales.excessList.filter(function (item) {
            return item.id == e
        })
        /* eslint eqeqeq: "warn" */
        if (excessItem[0].id !== this.props.sales.selectedExcess.id) {
            this.props.dispatchUpdateExcess(excessItem[0])
        }
    }

    async handleRemoveVap() {
        await this.props.dispatchRemoveCoverFromQuote(this.props.sales.kingsCab.quoteCoverId)
    }

    async handleCoverRemoval() {
        window.scrollTo(0, 0);
        await this.props.dispatchShowRemoveCoverFromQuoteModal({ name: this.props.profile.selectedPersonalCover.riskItems[0].description }, this.handleToggleReasons);
    }

    async handleToggleReasons() {
        await this.setState({
            cancelCoverReasons: true
        })
    }

    async handleRemoveAccessory() {
        var accessory = {
            Id: this.props.sales.leatherSeats.id,
            ReplacementValue: this.props.sales.leatherSeats.replacementValue,
            QuoteCarAccessoryId: this.props.sales.leatherSeats.quoteCarAccessoryId
        }
        await this.props.dispatchRemoveAccessory(accessory)
    }

    async handleExcessDropdownToggle(e: any) {
        await this.setState({
            selectedExcessDropdown: !this.state.selectedExcessDropdown
        });
    }

    async handleShowMore(e: any) {
        await this.setState({
            showMore: !this.state.showMore
        });
    }

    async handleShowSelfInspectPhotos() {
        this.props.dispatchToggleSelfInspectPhotos(!this.props.selfInspect.showSelfInspectPhotos);
    }

    async handleAcceptQuote(e: any) {
        if (this.props.sales.isNewItem) {
            this.props.dispatchAcceptQuote()
        }
        else {
            this.props.dispatchUpdateItemOnQuote()
        }
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    async handleAddAccesory(e: any) {
        let item = this.props.sales.carDetails.accessories.filter(accessory => accessory.id === e)
        this.props.dispatchShowAddAccessory(item[0])
    }

    async handleEditAccesory(e: any) {
        let item = this.props.sales.carDetails.accessories.filter(accessory => accessory.id === e)
        this.props.dispatchShowAddAccessory(item[0])
    }

    async handleAddVap(e: any) {
        this.props.dispatchShowAddVap(e)
    }

    async handleAddVapCarHire(e: any) {
        this.props.dispatchShowAddCarHire(e);
    }

    async handleAddVapTyreAndRim(e: any) {
        let selectedVap = this.props.sales.carDetails.vaps.filter(vap => vap.id === e)[0]
        if (selectedVap.comboAdded) {
            this.props.dispatchShowErrorModal(VAPS_ADD_TYRE_SCRATCH)
        }
        else {
            this.props.dispatchShowTyreAndRim(e)
        }
    }

    async handleAddVapScratchAndDent(e: any) {
        let selectedVap = this.props.sales.carDetails.vaps.filter(vap => vap.id === e)[0]
        if (selectedVap.comboAdded) {
            this.props.dispatchShowErrorModal(VAPS_ADD_TYRE_SCRATCH)
        }
        else {
            this.props.dispatchShowAddVap(e)
        }
    }

    async handleAddVapLittleDings(e: any) {
        let selectedVap = this.props.sales.carDetails.vaps.filter(vap => vap.id === e)[0]
        if (selectedVap.comboAdded) {
            this.props.dispatchShowErrorModal(VAPS_ADD_COMBINED)
        }
        else {
            this.props.dispatchShowAddLittleDings(e)
        }
    }

    async handleAddVapCredit(e: any) {
        this.props.dispatchShowAddCreditShortfall(e)
    }

    async handleAddVapRafAssist(e: any) {
        this.props.dispatchShowAddRafAssist(e)
    }

    async toggleRaf() {
        let raf = this.props.sales.rafAssist;
        raf.isActive = !raf.isActive;
        this.props.dispatchToggleRaf(raf);
    }

    async editPolicyInfo() {
        this.props.dispatchShowUpdatePolicy(AMEND_POLICY_CAR);
    }

    async saveEdit() {
        await this.props.dispatchGetQuoteMobilePaymentSchedule();
        this.props.dispatchShowBankingDetails()
        await this.setState({
            updateEditing: !this.state.showMore
        })
    }

    async dismissInspectionReminder() {

        await this.setState({
            reminderDismissed: !this.state.showMore
        })
    }

    handleSelfInspectionRequired() {
        this.props.dispatchSyncCoverWithProfile();
    }

    async submitAClaim() {
        await this.props.dispatchResetFNOL();
        await this.props.dispatchClearSelectedDamages();
        await this.props.dispatchSetCoverSelected(this.props.profile.selectedPersonalCover);
        await this.props.dispatchSetStep(1, 1)
        await this.handleRedirect(FNOL_SUBMIT_CLAIM);
    }

    handleCallMeBackModal() {
        this.props.handleCallMeBack()
    }

    addNewProduct() {
        this.props.dispatchAddProduct(PRODUCT_COMPREHENSIVE_CAR);
    }

    ShowCancelEdit() {
        this.props.dispatchShowCancelPolicyEdit();
    }

    ShowCallBackVap() {
        this.props.dispatchShowCancelVapPopup();
    }

    handleNewItem() {
        this.props.dispatchShowAddNewItem();
    }

    handleAccordianArrow(e: any) {
        this.setState({ accordionFAQActiveKey: e })
    }

    render() {

        const cover = this.props.profile.selectedPersonalCover;
        let faq = this.getDropdownItems(cover);
        const { reminderDismissed, accordian0Open, accordian1Open, accordian2Open } = this.state;
        const profileState = this.props.profile;
        const isMobile = window.innerWidth <= 975;
        let selfInspectionRequired = <>Self-inspection required.
            <Link id="SubmitMonthlyMileageBannerLink" className="Link-monthly-mileage-reminder" to="#" onClick={this.handleSelfInspectionRequired} >Click here.</Link></>

        if (window.innerWidth < 359) {
            selfInspectionRequired = <> Self-inspection required.<br />
                <Link id="SubmitMonthlyMileageBannerLink" className="Link-monthly-mileage-reminder" to="#" onClick={this.handleSelfInspectionRequired} >Click here.</Link></>
        }

        let excessDropDown = [];
        if (this.props.sales.excessList) {
            if (this.props.sales.excessList.length > 0) {
                excessDropDown = this.props.sales.excessList.map((item) => {
                    return <Dropdown.Item eventKey={item.id} key={item.id}>{this.props.profile.currencySymbol} {item.description}</Dropdown.Item>
                });
            }
        }

        let vapsList = "";
        if (this.props.sales.isInEdit) {
            if (this.props.sales.carDetails.vaps) {
                if (this.props.sales.carDetails.vaps.length > 0) {
                    vapsList = this.props.sales.carDetails.vaps.map((item) => {
                        if (item.id.toUpperCase() === "4C0CB071-42DD-4060-99FF-9F0214113467") { /*credit shortfall*/
                            return <OptionalExtraTile id={item.id}
                                hasVAP={item.isActive}
                                productName={item.title}
                                imageClass={item.icon}
                                addItem={this.handleAddVapCredit.bind(this)}
                                removeItem={this.handleAddVapCredit.bind(this)}
                                canUse={this.props.sales.isInEdit}
                                cost={this.props.profile.currencySymbol + " " + item.subtitle + " pm"}
                                isAccessory={false} />
                        }
                        else if (item.id.toUpperCase() === "916E328E-AD96-4D6C-A3E8-42B095BCB805") {/*tyre and rim*/
                            return <OptionalExtraTile id={item.id}
                                hasVAP={item.isActive}
                                productName={item.title}
                                imageClass={item.icon}
                                addItem={this.handleAddVapTyreAndRim.bind(this)}
                                removeItem={this.handleAddVapTyreAndRim.bind(this)}
                                canUse={this.props.sales.isInEdit}
                                cost={this.props.profile.currencySymbol + " " + item.subtitle + " pm"}
                                isAccessory={false} />
                        }
                        else if (item.id.toUpperCase() === "0EC1DCAA-A6F7-4C86-905A-00FD55022569") {/*scratch and dent*/
                            return <OptionalExtraTile id={item.id}
                                hasVAP={item.isActive}
                                productName={item.title}
                                imageClass={item.icon}
                                addItem={this.handleAddVapScratchAndDent.bind(this)}
                                removeItem={this.handleAddVapScratchAndDent.bind(this)}
                                canUse={this.props.sales.isInEdit}
                                cost={this.props.profile.currencySymbol + " " + item.subtitle + " pm"}
                                isAccessory={false} />
                        }
                        else if (item.id.toUpperCase() === "5EEDC56C-F17A-4AB8-97CC-58E02D612865") {/*Little dings*/
                            return <OptionalExtraTile id={item.id}
                                hasVAP={item.isActive}
                                productName={item.title}
                                imageClass={item.icon}
                                addItem={(e) => this.handleAddVapLittleDings(e)}
                                removeItem={(e) => this.handleAddVapLittleDings(e)}
                                canUse={this.props.sales.isInEdit}
                                cost={this.props.profile.currencySymbol + " " + item.subtitle + " pm"}
                                isAccessory={false} />
                        }
                        else if (item.id.toUpperCase() === "4C0CB071-42DD-4060-99FF-9F0214113461") {/*car hire*/
                            return <OptionalExtraTile id={item.id}
                                hasVAP={item.isActive}
                                productName={item.title}
                                imageClass={item.icon}
                                addItem={this.handleAddVapCarHire.bind(this)}
                                removeItem={this.handleAddVapCarHire.bind(this)}
                                canUse={this.props.sales.isInEdit}
                                cost={this.props.profile.currencySymbol + " " + item.subtitle + " pm"}
                                isAccessory={false} />
                        }
                        else {
                            return <OptionalExtraTile id={item.id}
                                hasVAP={item.isActive}
                                productName={item.title}
                                imageClass={item.icon}
                                addItem={this.handleAddVap.bind(this)}
                                removeItem={this.handleAddVap.bind(this)}
                                canUse={this.props.sales.isInEdit}
                                cost={this.props.profile.currencySymbol + " " + item.subtitle + " pm"}
                                isAccessory={false} />
                        }
                    })
                }
            }
        }
        else {
            if (this.props.profile.selectedPersonalCover.vaps) {
                if (this.props.profile.selectedPersonalCover.vaps.length > 0) {
                    vapsList = this.props.profile.selectedPersonalCover.vaps.map((item) => {
                        if (item.id.toUpperCase() === "4C0CB071-42DD-4060-99FF-9F0214113467") { /*credit shortfall*/
                            return <OptionalExtraTile id={item.id}
                                hasVAP={item.isActive}
                                productName={item.title}
                                imageClass={item.icon}
                                addItem={this.handleAddVapCredit.bind(this)}
                                removeItem={this.handleAddVapCredit.bind(this)}
                                canUse={this.props.sales.isInEdit}
                                cost={this.props.profile.currencySymbol + " " + item.premiumText + " pm"}
                                isAccessory={false} />
                        }
                        else if (item.id.toUpperCase() === "916E328E-AD96-4D6C-A3E8-42B095BCB805") {/*tyre and rim*/
                            return <OptionalExtraTile id={item.id}
                                hasVAP={item.isActive}
                                productName={item.title}
                                imageClass={item.icon}
                                addItem={this.handleAddVapTyreAndRim.bind(this)}
                                removeItem={this.handleAddVapTyreAndRim.bind(this)}
                                canUse={this.props.sales.isInEdit}
                                cost={this.props.profile.currencySymbol + " " + item.premiumText + " pm"}
                                isAccessory={false} />
                        }
                        else if (item.id.toUpperCase() === "0EC1DCAA-A6F7-4C86-905A-00FD55022569") {/*scratch and dent*/
                            return <OptionalExtraTile id={item.id}
                                hasVAP={item.isActive}
                                productName={item.title}
                                imageClass={item.icon}
                                addItem={this.handleAddVapScratchAndDent.bind(this)}
                                removeItem={this.handleAddVapScratchAndDent.bind(this)}
                                canUse={this.props.sales.isInEdit}
                                cost={this.props.profile.currencySymbol + " " + item.premiumText + " pm"}
                                isAccessory={false} />
                        }
                        else if (item.id.toUpperCase() === "5EEDC56C-F17A-4AB8-97CC-58E02D612865") {/*Little dings*/
                            return <OptionalExtraTile id={item.id}
                                hasVAP={item.isActive}
                                productName={item.title}
                                imageClass={item.icon}
                                addItem={this.handleAddVapLittleDings.bind(this)}
                                removeItem={this.handleAddVapLittleDings.bind(this)}
                                canUse={this.props.sales.isInEdit}
                                cost={this.props.profile.currencySymbol + " " + item.premiumText + " pm"}
                                isAccessory={false} />
                        }
                        else if (item.id.toUpperCase() === "4C0CB071-42DD-4060-99FF-9F0214113461") {/*tyre and rim + scratch and dent*/
                            return <OptionalExtraTile id={item.id}
                                hasVAP={item.isActive}
                                productName={item.title}
                                imageClass={item.icon}
                                addItem={this.handleAddVapCarHire.bind(this)}
                                removeItem={this.handleAddVapCarHire.bind(this)}
                                canUse={this.props.sales.isInEdit}
                                cost={this.props.profile.currencySymbol + " " + item.premiumText + " pm"}
                                isAccessory={false} />
                        }
                        else {
                            return <OptionalExtraTile id={item.id}
                                hasVAP={item.isActive}
                                productName={item.title}
                                imageClass={item.icon}
                                addItem={this.handleAddVap.bind(this)}
                                removeItem={this.handleAddVap.bind(this)}
                                canUse={this.props.sales.isInEdit}
                                cost={this.props.profile.currencySymbol + " " + item.premiumText + " pm"}
                                isAccessory={false} />
                        }
                    })
                }
            }
        }

        let accessoryList = "";
        if (this.props.sales.isInEdit) {
            if (this.props.sales.carDetails.accessories) {
                if (this.props.sales.carDetails.accessories.length > 0) {
                    accessoryList = this.props.sales.carDetails.accessories.map((item) => {
                        return <OptionalExtraTile id={item.id}
                            hasVAP={item.isActive}
                            productName={item.title}
                            imageClass={item.icon}
                            addItem={this.handleAddAccesory.bind(this)}
                            removeItem={this.handleAddAccesory.bind(this)}
                            canUse={this.props.sales.isInEdit}
                            cost={this.props.profile.currencySymbol + " " + item.subtitle}
                            isAccessory={true} />
                    })
                }
            }
        }
        else {
            if (this.props.profile.selectedPersonalCover.accessories) {
                if (this.props.profile.selectedPersonalCover.accessories.length > 0) {
                    accessoryList = this.props.profile.selectedPersonalCover.accessories.map((item) => {
                        return <OptionalExtraTile id={item.id}
                            hasVAP={item.isActive}
                            productName={item.title}
                            imageClass={item.icon}
                            addItem={this.handleAddAccesory.bind(this)}
                            removeItem={this.handleAddAccesory.bind(this)}
                            canUse={this.props.sales.isInEdit}
                            cost={this.props.profile.currencySymbol + " " + item.subtitle}
                            isAccessory={true} />
                    })
                }
            }
        }

        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }];

        let coverStartDate = (cover.riskItems[0].coverStartDate?.toString().trim().length > 0) ? cover.riskItems[0].coverStartDate : "";

        let coverType = "Comprehensive cover on retail value";
        switch (cover.productId.toUpperCase()) {
            case THEFT_WRITEOFF_CAR_COVER_TYPE: { coverType = "Motor theft and write off"; break; }
            case THIRDPARTY_CAR_COVER_TYPE: { coverType = "Third party"; break; }
            case THIRDPARTY_FIRETHEFT_CAR_COVER_TYPE: { coverType = "Third party fire and theft"; break; }
            case COMPREHENSIVE_CAR_COVER_TYPE: { coverType = "Comprehensive cover on retail value"; break; }
            case AGREED_VALUE_COVER_TYPE: { coverType = "Comprehensive cover on agreed value"; break; }
            case CHILLI_CAR_COVER_TYPE: { coverType = "Chilli"; break; }
        }

        return (
            <>
                {cover !== '' && <>
                    {isMobile &&
                        <KPBreadCrumb navList={BreadcrumbDetails} activePage="Car" />
                    }
                    {!this.state.cancelCoverReasons &&
                        <>

                            {this.props.sales.isInEdit && !this.props.selfInspect.showSelfInspectPhotos &&
                                <div id="Update-policy" className="card col-12 mb-3">
                                    <div className="card-body text-centerThat decrease monthly">

                                        <h3>Update your policy</h3>
                                        <p>Here you can add or remove cover/accessories from your policy, and even change your basic excess.</p>
                                        <p>Hit <b>'Save'</b> to apply your changes, or <b>'Cancel'</b> to undo them.</p>
                                        <p><b>Please note:</b> You'll need to confirm your banking details and accept our legal terms to finish updating your policy.</p>

                                        <div className="row mt-3 mb-3 update-policy-button-holder">
                                            <div className="col-12 col-lg-6 order-lg-1">
                                                <button className="btn btn-outline-white mt-lg-0 mb-2 mt-2 float-lg-right" onClick={this.saveEdit} id='SavePersonalEdit'>Save</button>
                                            </div>

                                            <div className="col-12 col-lg-6 order-lg-2 mt-3 mt-lg-0">
                                                <button className="btn btn-outline-white mr-lg-0 mb-2 float-lg-left" onClick={this.ShowCancelEdit} id='CancelPolicyEdit'>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="card">
                                {!reminderDismissed && cover.riskItems[0].inspectionRequired &&
                                    <div className="Reminder-banner banner-padding">
                                        <div className="cursor-pointer row noma" onClick={this.handleSelfInspectionRequired}>
                                            <div className="nopa mr-15px">
                                                <img src="Images/White.svg" className="warning-icon-car" />
                                            </div>
                                            <div className="col-10 nopa">
                                                <p className="Monthly-mileage-update-car mb-0px">Self-inspection required. <Link onClick={this.handleSelfInspectionRequired} id="SubmitMonthlyMileageBannerLink" className="Link-monthly-mileage-reminder-car">Tap here.</Link> </p>
                                            </div>
                                        </div>
                                        <div onClick={this.dismissInspectionReminder}>
                                            <Image className="Reminder-banner-close-img-car" src="Images/icons-navigation-close-16-px-white.svg" alt="Dismiss" />
                                        </div>
                                    </div>
                                }
                                {!this.props.selfInspect.showSelfInspectPhotos &&
                                    <div className={(cover.riskItems[0].inspectionRequired !== "" && cover.riskItems[0].inspectionRequired !== null) && !reminderDismissed ? "" : "padding-top"} id="Policy-details-car">
                                        <div className={this.props.sales.isInEdit ? "noma nopa" : "row noma nopa"}>
                                            {this.props.sales.isInEdit &&
                                                <>
                                                    <div className="col-lg-8 col-md-8 col-12 nopa">
                                                        <p className="font-size-22px font-weight-bold line-height-normal mb-10px">{cover.riskItems[0].description}</p>
                                                    </div>
                                                    <div className="row nopa noma">
                                                        <div className="col-6 noma nopa">
                                                            <p className="font-weight-normal line-height-normal mb-1px">New car insurance premium</p>
                                                            <p className={this.props.sales.isInEdit ? 'amendmentCoverAmount mb-3' : 'coverAmount mb-3'}>{profileState.currencySymbol}{this.props.sales.isInEdit ? this.props.sales.carPremium : cover.riskItems[0].premium}pm</p>
                                                        </div>
                                                        {this.props.sales.isInEdit && this.props.profile && this.props.profile.personalPolicies[0].totalPolicyPremium &&
                                                            <>
                                                                <div className="col-6 noma nopa text-right">
                                                                    <p className="mb-0">New total monthly premium</p>
                                                                    <h3 className='amendmentCoverAmount mb-3'>{profileState.currencySymbol}{this.props.sales.totalPremium}pm</h3>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                </>
                                            }

                                            {!this.props.sales.isInEdit &&
                                                <>
                                                    <div className="col-lg-8 col-md-8 col-12 nopa">
                                                        <p className="font-size-22px font-weight-bold line-height-normal mb-10px">{cover.riskItems[0].description}</p>
                                                        {!this.props.sales.isInEdit &&
                                                            <div>    
                                                                <p className="font-weight-normal line-height-normal mb-3px">{ coverType }</p>
                                                                <p className={this.props.sales.isInEdit ? 'amendmentCoverAmount mb-3' : 'coverAmount mb-3'}>{profileState.currencySymbol}{this.props.sales.isInEdit ? this.props.sales.carPremium : cover.riskItems[0].premium}pm</p>
                                                                {coverStartDate.length > 0 &&
                                                                    <div>
                                                                        <p className="font-weight-normal line-height-normal mb-0">Cover start date</p>
                                                                        <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                                                    </div>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="col-lg-4 col-md-4 col-12 nopa text-lg-right text-center">
                                                        <div className="bling-update-polic-button-holder">
                                                            <div className="mb-10px">
                                                                <button className="btn btn-outline-red" onClick={this.editPolicyInfo} id="EditPolicy">Update policy</button>
                                                            </div>
                                                            <div>
                                                                <button className="btn btn-solid-aqua" onClick={this.submitAClaim}>Submit a claim</button>
                                                            </div>
                                                            {cover.riskItems[0].inspectionRequired && !this.props.sales.isInEdit &&
                                                                <div className="mt-10px">
                                                                    <button className="self-inspection-button btn" onClick={this.handleSelfInspectionRequired}>Self-inspection required</button>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            {!this.props.sales.isInEdit && cover.productId.toUpperCase() === AGREED_VALUE_COVER_TYPE && cover.riskItems[0].vehicleDetails.agreedValueEffectiveDate && cover.riskItems[0].vehicleDetails.agreedValueEndDate &&
                                                <>
                                                    <div className="row col-12 mt-15px">
                                                        <div className="col-6 nopa">
                                                            <p className="font-size-16px"><b>Agreed value start date</b></p>
                                                            <p className="font-weight-normal line-height-normal cover-date-height font-size-16px">{cover.riskItems[0].vehicleDetails.agreedValueEffectiveDate.split("T", 2)[0]}</p>
                                                        </div>
                                                        <div className="col-6 nopa">
                                                            <p className="font-size-16px"><b>Agreed value end date</b><img className="raftooltip ml-10px" id="agreedTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for="agreedValueTooltip" data-tip="" />
                                                                <ReactTooltip id="agreedValueTooltip" className="text-left tooltip-gray" place="right" effect="solid" backgroundColor="#CAD0D5" delayShow={1000}>The agreed value that’s noted on your policy schedule refers to the amount that the car is covered for, for the 3 years following the start of the cover.</ReactTooltip></p>
                                                            <p className="font-weight-normal line-height-normal font-size-16px">{cover.riskItems[0].vehicleDetails.agreedValueEndDate.split("T", 2)[0]}</p>
                                                        </div>
                                                    </div>
                                                    <hr className="policy-details-hr mt-14px mb-15px col-12" />
                                                    <p className="col-12 font-size-16px nopa"><b>Agreed value</b></p>
                                                    <div className="row col-12">
                                                        <div className="col-6 nopa">
                                                            <p className="font-size-16px"><b>Current agreed value</b></p>
                                                            <p className="font-weight-normal line-height-normal font-size-16px">{this.props.profile.currencySymbol} {cover.riskItems[0].vehicleDetails.agreedValue.toFixed(2)}</p>
                                                        </div>
                                                        <div className="col-6 nopa">
                                                            <p className="font-size-16px"><b>Current retail value</b></p>
                                                            <p className="font-weight-normal line-height-normal font-size-16px">{this.props.profile.currencySymbol} {cover.riskItems[0].vehicleDetails.retailValue.toFixed(2)}</p>
                                                        </div>
                                                    </div>
                                                    <hr className="policy-details-hr mt-14px mb-15px" />
                                                </>
                                            }
                                            {this.props.sales.isInEdit && this.props.profile.countryId === SA_COUNTRY_ID_NUMBER &&
                                                <div>
                                                    <AgreedValueBlock />
                                                </div>
                                            }
                                            <div className="col-12 nopa">
                                                <hr className="policy-details-hr" />
                                                {!this.props.sales.isInEdit &&
                                                    <>
                                                        <p className="font-size-16px font-weight-bold mb-3px">Excess amount</p>
                                                        <p className="excessAmount mb-3px">{(cover.riskItems[0] && cover.riskItems[0].excessDescription === null) ? (profileState.currencySymbol + cover.excess) : cover.riskItems[0].excessDescription}</p>
                                                    </>
                                                }
                                                {this.props.sales.isInEdit &&
                                                    <>
                                                        <div className="col-12 nopa mt-3" id="Policy_Details">
                                                            <div className="row noma">
                                                                <div className="col-lg-6 col-12 nopa">
                                                                    <p className="productSummary-title mb-14px mt-lg-3">Choose your excess</p>
                                                                </div>
                                                                <div className="col-lg-6 col-12 nopa">
                                                                    <Dropdown className="fit-full"
                                                                        onSelect={this.handleExcessSelection}
                                                                        onToggle={this.handleExcessDropdownToggle}>
                                                                        <Dropdown.Toggle id="dropdown-excess">
                                                                            <div className="row">
                                                                                <div className="col-10">
                                                                                    {this.props.profile.currencySymbol} {this.props.sales.selectedExcess.description}
                                                                                </div>
                                                                                <Image src='Images/icons-arrow-dropdown-up-white-24-px.svg' className={this.state.selectedRegularDriverDropdown ? 'visible' : 'invisible'} alt="" />
                                                                                <Image src='Images/icons-arrow-dropdown-down-white-24-px.svg' className={this.state.selectedRegularDriverDropdown ? 'invisible' : 'visible'} alt="" />
                                                                            </div>
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            {excessDropDown}
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                            </div>
                                                            <div className="row noma mt-20px">
                                                                <p className="font-size-12px font-weight-normal line-height-normal mb-0px"><strong>Please note:</strong> If something happens for which you need to claim, you’ll be expected to pay the basic excess amount, as noted on your policy schedule. You may also be expected to pay any of the additional excess amounts (refer to your policy schedule).</p>
                                                            </div>
                                                        </div>
                                                        {!this.props.sales.isInEdit &&
                                                            <div className="row justify-content-center mt-3">
                                                                <div className="col-12">
                                                                    <p className="Overview-only-Pleas">Overview only. Please refer to our <a target="_blank" href="Documents/King-price-insurance-policy.pdf">KPPD</a> and your policy schedule for more info.</p>
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                }
                                                {!this.props.sales.isInEdit &&
                                                    <>
                                                        <hr className="policy-details-hr mt-14px mb-15px" />
                                                        <p className="font-size-16px font-weight-bold line-height-normal mb-11px">Benefits</p>
                                                        <div id="BenefitsDiv">
                                                            <div className="row noma">
                                                                <div className="col-xl-3 col-md-6 col-12 mb-sm-21px nopa">
                                                                    <div className="row noma ">
                                                                        <div className="mr-8px">
                                                                            <div className="icon-checkmark-circle"></div>
                                                                        </div>
                                                                        <div className="col nopa mb-0px mt-3px">
                                                                            <p className="mb-0px BenefitsItems">Roadside assist</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {this.props.profile.countryId !== 157 &&
                                                                    <>
                                                                        <div className="col-xl-3 col-md-6 col-12 mb-sm-21px nopa">
                                                                            <div className="row noma ">
                                                                                <div className="mr-8px">
                                                                                    <div className="icon-checkmark-circle"></div>
                                                                                </div>
                                                                                <div className="col nopa mb-0px mt-3px">
                                                                                    <p className="mb-0px BenefitsItems">Accident assist</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-xl-3 col-md-6 col-12 mb-sm-21px nopa">
                                                                            <div className="row noma ">
                                                                                <div className="mr-8px">
                                                                                    <div className="icon-checkmark-circle"></div>
                                                                                </div>
                                                                                <div className="col nopa mb-0px mt-3px">
                                                                                    <p className="mb-0px BenefitsItems">Medical assist</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-xl-3 col-md-6 col-12 nopa">
                                                                            <div className="row noma ">
                                                                                <div className="mr-8px">
                                                                                    <div className="icon-checkmark-circle"></div>
                                                                                </div>
                                                                                <div className="col nopa mb-0px mt-3px">
                                                                                    <p className="mb-0px BenefitsItems">Liability to other parties</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                                {!cover.riskItems[0].inspectionRequired && this.props.ssp.selfInspectionEnabled && !this.props.selfInspect.showSelfInspectPhotos &&
                                                    <>
                                                        <hr className="policy-details-hr mt-13px mb-15px" />
                                                        <div className="inspectionBlock row noma text-lg-left text-center">
                                                            <div className="nopa inspectionPolicyProduct">
                                                                <img src="./Images/OnlineQuotes/icon-addcover-car-insurance.svg" title="Car insurance" alt="car insurance" className="add-cover-image" />
                                                            </div>
                                                            <div className="col-lg col-12 nopa">
                                                                <div className="row noma">
                                                                    <div className="col-lg-8 col-12 px-0 nopa">
                                                                        <p className="mb-0 font-size-16px font-weight-bold mt-lg-10px">Self-inspection complete</p>
                                                                    </div>
                                                                    <div className="col-lg col-12 nopa text-lg-right mt-sm-15px mt-lg-0px">
                                                                        <button className="btn btn-solid-red inspection-view-btn" onClick={this.handleShowSelfInspectPhotos}>View details</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                                <hr className="policy-details-hr mt-14px mb-15px" />
                                                {vapsList &&
                                                    <>
                                                        <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Optional cover</p>
                                                        <p className="font-weight-500 line-height-normal mb-10px">Here’s a list of the optional extra cover you’ve added to your policy… To add more cover, tap on the button below</p>
                                                        <div id="OptionalExtras" className="mt-lg-4">
                                                            {vapsList}
                                                        </div>
                                                        {!this.props.sales.isInEdit &&
                                                            <div className="hideOverflow">
                                                                <div className="float-right addMore-button-col mt-20px">
                                                                    <button className="btn btn-solid-green" onClick={this.editPolicyInfo} id="addMoreVap">Add optional cover</button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                }
                                                {!vapsList &&
                                                    <>
                                                        <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Optional cover</p>
                                                        <p className="font-weight-500 line-height-normal mb-10px">These products come with a small additional premium but offer major peace of mind. To add cover, tap on the button below</p>
                                                        {!this.props.sales.isInEdit &&
                                                            <div className="hideOverflow">
                                                                <div className="float-right addMore-button-col mt-20px">
                                                                    <button className="btn btn-solid-green" onClick={this.editPolicyInfo} id="addMoreVap">Add optional cover</button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                }
                                                <hr className="policy-details-hr mt-14px mb-30px" />
                                                {accessoryList &&
                                                    <>
                                                        <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Accessories</p>
                                                        <p className="font-weight-500 line-height-normal mb-10px">Here’s a list of the accessories you’ve added to your policy… To add more accessories, tap on the button below</p>
                                                        <div id="Accessories">
                                                            {accessoryList}
                                                        </div>
                                                        {!this.props.sales.isInEdit &&

                                                            <div className="hideOverflow">
                                                                <div className="float-right addMore-button-col mt-20px">
                                                                    <button className="btn btn-solid-green" onClick={this.editPolicyInfo} id="addMoreAccessorie">Add accessories</button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                }
                                                {!accessoryList &&
                                                    <>
                                                        <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Accessories</p>
                                                        <p className="font-weight-500 line-height-normal mb-10px">The insured value of your car covers the value of the car, including the standard,
                                                        factory-fitted sound equipment and accessories. If your car has additional extras which
                                                        aren’t standard and/or factory-fitted, you must specify and insure them separately in
                                                            order to have cover for them. To add accessories, tap on the button below</p>
                                                        {!this.props.sales.isInEdit &&
                                                            <div className="hideOverflow">
                                                                <div className="float-right addMore-button-col mt-20px">
                                                                    <button className="btn btn-solid-green" onClick={this.editPolicyInfo} id="addMoreAccessorie">Add accessories</button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                }
                                                <hr className="policy-details-hr mt-14px mb-20px" />
                                            </div>
                                            <div className="col-12 nopa">
                                                {!this.props.sales.isInEdit &&
                                                    <div id="DetailsDiv" className="new-ssp-faq-block">
                                                        <Accordion>
                                                            <div className="pr-2 new-ssp-code-red-faq-block code-red-accordion-holder">
                                                                <Accordion onSelect={(e) => this.handleAccordianArrow(Number(e))}>
                                                                    {faq}
                                                                </Accordion>
                                                            </div>
                                                        </Accordion>
                                                    </div>
                                                }
                                            </div>

                                            <div className="d-lg-none d-none" id="PolicyDetailsMobile" style={{ display: "none" }}>
                                                <div className="pl-3 pr-3">
                                                    <div id="firstDivMobile" className="border-bottom">
                                                        <h2 className="carName mb-0 pt-3">{cover.riskItems[0].description}</h2>
                                                        <div className="row">
                                                            <div className="col-12 noma nopa">
                                                                {!this.props.sales.isInEdit &&
                                                                    <p className="mb-0">Comprehensive cover (on retail value)</p>
                                                                }
                                                                {this.props.sales.isInEdit &&
                                                                    <p className="mb-0">New car insurance premium</p>
                                                                }
                                                                {this.props.sales.isInEdit &&
                                                                    <h3 className={'amendmentCoverAmount mb-3'}>{profileState.currencySymbol}{this.props.sales.carPremium}pm</h3>
                                                                }
                                                                {!this.props.sales.isInEdit &&
                                                                    <h3 className={'coverAmount mb-3'}>{profileState.currencySymbol}{cover.riskItems[0].premium}pm</h3>
                                                                }
                                                            </div>
                                                            {this.props.sales.isInEdit &&
                                                                <div className="col-12 noma nopa">
                                                                    <p className="mb-0">New total monthly premium</p>
                                                                    <h3 className='amendmentCoverAmount mb-3'>{profileState.currencySymbol}{this.props.sales.totalPremium}pm</h3>
                                                                </div>
                                                            }
                                                        </div>

                                                        {!this.props.sales.isInEdit &&
                                                            <div className="row mb-3">
                                                                <div className="col-12">
                                                                    <button className="btn btn-outline-red mt-3" onClick={this.editPolicyInfo}>Edit policy</button>
                                                                </div>
                                                            </div>
                                                        }
                                                        {!this.props.sales.isInEdit &&
                                                            <div className="row mb-3">
                                                                <div className="col-12">
                                                                    <button className="btn btn-solid-aqua" onClick={this.submitAClaim}>Submit a claim</button>
                                                                </div>
                                                            </div>
                                                        }
                                                        {cover.riskItems[0].inspectionRequired && !this.props.sales.isInEdit &&
                                                            <div className="row mb-3">
                                                                <div className="col-12">
                                                                    <button className="btn btn-solid-red" onClick={this.handleSelfInspectionRequired}>Self-inspection required</button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="border-bottom mt-3">
                                                        {!this.props.sales.isInEdit &&

                                                            <div className="">
                                                                <p className="mb-1"><b>Excess amount</b></p>
                                                                <p className="excessAmount">{(cover.riskItems[0] && cover.riskItems[0].excessDescription === null) ? (profileState.currencySymbol + cover.excess) : cover.riskItems[0].excessDescription}</p>
                                                            </div>
                                                        }
                                                        {this.props.sales.isInEdit &&
                                                            <div className="row">
                                                                <div className="col-lg-6 col-12">
                                                                    <p className="productSummary-title mt-lg-3">Choose your excess</p>
                                                                </div>
                                                                <div className="col-12">
                                                                    <Dropdown className="fit-full"
                                                                        onSelect={this.handleExcessSelection}
                                                                        onToggle={this.handleExcessDropdownToggle}>
                                                                        <Dropdown.Toggle id="dropdown-excess">
                                                                            <div className="row">
                                                                                <div className="col-10">
                                                                                    {this.props.profile.currencySymbol} {this.props.sales.selectedExcess.description}
                                                                                </div>
                                                                                <Image src='Images/icons-arrow-dropdown-up-white-24-px.svg' className={this.state.selectedRegularDriverDropdown ? 'visible' : 'invisible'} alt="" />
                                                                                <Image src='Images/icons-arrow-dropdown-down-white-24-px.svg' className={this.state.selectedRegularDriverDropdown ? 'invisible' : 'visible'} alt="" />
                                                                            </div>
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            {excessDropDown}
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                    <p><strong>Please note:</strong> For certain claims and circumstances, an additional excess may apply. Check your policy schedule for more info.</p>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    {!this.props.sales.isInEdit &&
                                                        <div id="BenefitsDiv" className="mt-3">
                                                            <p className="Benefits">Benefits</p>
                                                            <div className="row">
                                                                <ul className="benefitsCheck">
                                                                    <li>Roadside assist</li>
                                                                    {this.props.profile.countryId !== 157 &&
                                                                        <>
                                                                            <li>Accident assist</li>
                                                                            <li>Medical assist</li>
                                                                            <li>Liability to other parties</li>
                                                                        </>
                                                                    }
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div id="OptionalExtras" className="mt-lg-4">
                                                        <>
                                                            {vapsList &&
                                                                <>
                                                                    <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Optional cover</p>
                                                                    <p className="font-weight-500 line-height-normal mb-10px">Here’s a list of the optional extra cover you’ve added to your policy… To add more cover, tap on the button below</p>
                                                                    <div id="OptionalExtras">
                                                                        {vapsList}
                                                                    </div>
                                                                    <div className="float-right">
                                                                        <button className="btn btn-solid-green" onClick={this.editPolicyInfo} id="addMoreVap">Add optional cover</button>
                                                                    </div>
                                                                </>
                                                            }
                                                            {!vapsList &&
                                                                <>
                                                                    <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Optional cover</p>
                                                                    <p className="font-weight-500 line-height-normal mb-10px">These products come with a small additional premium but offer major peace of mind. To add cover, tap on the button below</p>
                                                                    <div className="float-right">
                                                                        <button className="btn btn-solid-green" onClick={this.editPolicyInfo} id="addMoreVap">Add optional cover</button>
                                                                    </div>
                                                                </>
                                                            }
                                                        </>
                                                        <hr className="policy-details-hr mt-14px mb-30px" />
                                                    </div>
                                                    {/*/// Mobile View ///*/}
                                                    <div id="Accessories">
                                                        {accessoryList &&
                                                            <>
                                                                <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Accessories</p>
                                                                <p className="font-weight-500 line-height-normal mb-10px">Here’s a list of the accessories you’ve added to your policy… To add more accessories, tap on the button below</p>
                                                                <div id="Accessories">
                                                                    {accessoryList}
                                                                </div>
                                                                <div className="float-right">
                                                                    <button className="btn btn-solid-green" onClick={this.editPolicyInfo} id="addMoreAccessorie">Add accessories</button>
                                                                </div>
                                                            </>
                                                        }
                                                        {!accessoryList &&
                                                            <>
                                                                <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Accessories</p>
                                                                <p className="font-weight-500 line-height-normal mb-10px">The insured value of your car covers the value of the car, including the standard,
                                                                factory-fitted sound equipment and accessories. If your car has additional extras which
                                                                aren’t standard and/or factory-fitted, you must specify and insure them separately in
                                                                    order to have cover for them. To add accessories, tap on the button below</p>
                                                                <div className="float-right">
                                                                    <button className="btn btn-solid-green" onClick={this.editPolicyInfo} id="addMoreAccessorie">Add accessories</button>
                                                                </div>
                                                            </>
                                                        }
                                                        <hr className="policy-details-hr mt-14px mb-15px" />
                                                    </div>
                                                    {!this.props.sales.isInEdit &&
                                                        <div id="DetailsDiv" className="mt-4 pb-3">
                                                            <Accordion>
                                                            <Card className="">
                                                                <div className="pr-2 new-ssp-code-red-faq-block code-red-accordion-holder">
                                                                    <Accordion onSelect={(e) => this.handleAccordianArrow(Number(e))}>
                                                                        {faq}
                                                                    </Accordion>
                                                                </div>
                                                            </Card>
                                                            </Accordion>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {this.props.selfInspect.showSelfInspectPhotos &&
                                    <div className="mt-10px mb-10px">
                                        {!this.props.selfInspect.hasError &&
                                            <div className="ml-10px">
                                                <div className="col-lg-8 col-md-8 col-12 nopa">
                                                    <p className="font-size-22px font-weight-bold line-height-normal mb-10px mb-15px">Car self-inspection details</p>
                                                    <div className="mb-10px">
                                                        <p className="font-weight-normal line-height-normal mb-3px">{cover.riskItems[0].description}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <SelfinspectDetails />
                                    </div>
                                }
                            </div>
                            {!this.props.selfInspect.showSelfInspectPhotos &&
                                <Card className="mt-3 mb-5 cursor-pointer">
                                    <Card.Body>
                                        <div className="row noma" onClick={this.handleNewItem}>
                                            <div className="nopa mr-20px">
                                                <img src="./Images/OnlineQuotes/icon-addcover-car-insurance.svg" title="Car insurance" alt="car insurance" className="add-cover-image" />
                                            </div>
                                            <div className="col-lg col-9 nopa">
                                                <div className="row noma">
                                                    <div className="col-11 px-0 mt-3 nopa">
                                                        <p className="mb-0"><b>Add car insurance</b></p>
                                                    </div>
                                                    <div className="col-lg col-1 mt-2 pl-0 pl-lg-2 nopa" style={{ paddingTop: "2px" }}>
                                                        <Image src="./Images/TopNav/add-cover-nugreen-46px-46px.svg" className="mx-auto d-block cursor-pointer" onClick={this.addNewProduct} style={{ height: "30px" }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            }
                            {!this.props.sales.isInEdit && !this.props.selfInspect.showSelfInspectPhotos && this.props.ssp.removeCoverEnabled &&
                                <div className="row mb-5">
                                    <div className="col text-right">
                                        <button className={"btn btn-outline-red align-self-center" + (isMobile ? " w-100 remove-cover-mobile" : " remove-cover")} type="button" onClick={this.handleCoverRemoval}>Remove cover</button>
                                    </div>
                                </div>}

                            {this.props.selfInspect.showSelfInspectPhotos && !this.props.selfInspect.hasError &&
                                <>
                                    <div className="col-lg col-12 nopa text-sm-center text-lg-right mt-15px mb-15px">
                                        <button id="ViewSelfInspectBack" className="btn btn-solid-red w-sm-100" onClick={this.handleShowSelfInspectPhotos}>Back to personal policy</button>
                                    </div>
                                </>
                            }
                        </>
                    }
                    {this.state.cancelCoverReasons && !this.props.selfInspect.showSelfInspectPhotos &&
                        <div className="box mb-3 pl-20px pt-20px">
                            <CancelCoverReasons />
                        </div>
                    }
                </>}
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        auth: state.auth,
        ssp: state.ssp,
        selfInspect: state.selfInspect
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
        dispatchUpdateExcess: (excessItem) => dispatch(updateExcess(excessItem)),
        dispatchShowAddVap: (vap) => dispatch(showAddVap(vap)),
        dispatchShowAddAccessory: (accessory) => dispatch(showAddAccessory(accessory)),
        dispatchShowAddCarHire: (vapId) => dispatch(showAddCarHire(vapId)),
        dispatchShowAddCreditShortfall: (vap) => dispatch(showAddCreditShortfall(vap)),
        dispatchShowTyreAndRim: (vap) => dispatch(showTyreAndRim(vap)),
        dispatchShowAddLittleDings: (vap) => dispatch(showAddLittleDings(vap)),
        dispatchShowErrorModal: (error) => dispatch(showErrorModal(error)),
        dispatchAcceptQuote: () => dispatch(acceptQuote(false)),
        dispatchUpdateItemOnQuote: () => dispatch(refreshUpdatedCartItem()),
        dispatchShowBankingDetails: () => dispatch(showBankingDetails()),
        dispatchShowCancelVapPopup: () => dispatch(showCancelVapPopup()),
        dispatchShowCancelPolicyEdit: () => dispatch(showCancelPolicyEdit()),
        dispatchShowAddNewItem: () => dispatch(showAddNewItem()),
        dispatchShowComingSoon: () => dispatch(showComingSoon()),
        dispatchAddProduct: (action) => dispatch(addProduct(action)),
        dispatchGetSelfInspectPhotos: () => dispatch(getSelfInspectPhotos()),
        dispatchSyncCoverWithProfile: () => dispatch(syncCoverWithProfile()),
        dispatchShowAddRafAssist: (vap) => dispatch(showAddRafAssist(vap)),
        dispatchToggleRaf: (raf) => dispatch(toggleRaf(raf)),
        dispatchResetFNOL: () => dispatch(resetFNOL()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchClearSelectedDamages: () => dispatch(clearSelectedDamages()),
        dispatchSetCoverSelected: (riskItem) => dispatch(setCoverFromPersonalInsurance(riskItem)),
        dispatchRemoveCoverFromQuote: (coverId) => dispatch(removeCoverFromQuote(coverId)),
        dispatchRemoveAccessory: (accessory) => dispatch(removeAccessoryFromQuote(accessory)),
        dispatchShowRemoveCoverFromQuoteModal: (cover, handleToggleReasons) => dispatch(showRemoveCoverModal(cover, handleToggleReasons)),
        dispatchGetQuoteMobilePaymentSchedule: () => dispatch(getQuoteMobilePaymentSchedule()),
        dispatchShowUpdatePolicy: (value) => dispatch(showUpdatePolicyModal(value, '')),
        dispatchToggleSelfInspectPhotos: (value) => dispatch(toggleSelfInspectPhotos(value)),
        dispatchToggleHasError: (value) => dispatch(toggleHasError(value))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PolicyDetailsCar);